import Vue from 'vue';
import moment from 'moment';

Vue.filter('date', (value?: string) => {
  return value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : 'Unknown';
});

Vue.filter('timeLeft', (value?: string) => {
  if (value) {
    const durationInMs = new Date(value).getTime() - new Date().getTime();
    const humanDuration = moment
      .duration(durationInMs, 'milliseconds')
      .humanize(true);

    return value ? humanDuration : 'Unknown';
  }

  return 'Unknown';
});

Vue.filter('titlize', (value?: string) => {
  if (!value) return '';

  value = String(value);
  return value
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
});
